// Browser-side audio compression (WebCodecs via mediabunny): any audio/video -> mono Opus WebM.
const MIN_BYTES = 12 * 1024 * 1024;
const SMALL_EXT = ["webm", "ogg", "opus"];

export const shouldCompress = (blob, filename) => {
  const ext = (filename || "").split(".").pop().toLowerCase();
  return blob.size >= MIN_BYTES && !SMALL_EXT.includes(ext) && typeof window.AudioEncoder !== "undefined";
};

export async function compressAudio(blob, { onProgress, ctrl }) {
  const { Input, Output, Conversion, ALL_FORMATS, BlobSource, WebMOutputFormat, BufferTarget, canEncodeAudio } = await import("mediabunny");
  if (!(await canEncodeAudio("opus"))) return null;
  const input = new Input({ source: new BlobSource(blob), formats: ALL_FORMATS });
  const output = new Output({ format: new WebMOutputFormat(), target: new BufferTarget() });
  const conversion = await Conversion.init({
    input, output, video: { discard: true },
    audio: { codec: "opus", numberOfChannels: 1, sampleRate: 48000, bitrate: 32000 },
  });
  if (!conversion.isValid) return null;
  conversion.onProgress = (p) => onProgress(Math.round(p * 100));
  ctrl.cancelCompress = () => conversion.cancel();
  await conversion.execute();
  ctrl.cancelCompress = null;
  const out = new Blob([output.target.buffer], { type: "audio/webm" });
  return out.size < blob.size * 0.8 ? out : null;
}
